import { c as _c } from "react/compiler-runtime";
import styles from "@website/ui/menu/menu-item.module.scss";
import { MenuItemPropertiesType } from "@website/ui/menu/menu.types";
import { FC } from "react";
export const MenuItem: FC<MenuItemPropertiesType> = properties => {
  const $ = _c(21);
  const {
    title,
    description,
    StartIcon,
    EndIcon,
    selected,
    disabled,
    onClick,
    value,
    size: t0
  } = properties;
  const size = t0 === undefined ? "default" : t0;
  let t1;
  if ($[0] !== disabled || $[1] !== onClick || $[2] !== value) {
    t1 = () => {
      if (onClick && !disabled) {
        onClick(value);
      }
    };
    $[0] = disabled;
    $[1] = onClick;
    $[2] = value;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onClickItem = t1;
  const t2 = `${styles["menu-item"]} ${selected ? styles.selected : ""} ${disabled ? styles.disabled : ""} ${styles[size]}`;
  let t3;
  if ($[4] !== StartIcon) {
    t3 = StartIcon ? <div className={styles.start}>{StartIcon}</div> : null;
    $[4] = StartIcon;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== title) {
    t4 = <div className={styles.title}>{title}</div>;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== description) {
    t5 = description ? <div className={styles.description}>{description}</div> : null;
    $[8] = description;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className={styles.middle}>{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== EndIcon) {
    t7 = EndIcon ? <div className={styles.end}>{EndIcon}</div> : null;
    $[13] = EndIcon;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== onClickItem || $[16] !== t2 || $[17] !== t3 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className={t2} onClick={onClickItem}>{t3}{t6}{t7}</div>;
    $[15] = onClickItem;
    $[16] = t2;
    $[17] = t3;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};